/** Geteilte Anker-ID zwischen HeroRatingBadge (Link) und TestimonialsSection (Ziel) -
 * eigene Konstante statt zweier unabhaengig hartkodierter Strings, damit ein Tippfehler
 * an einer Stelle den Link nicht stillschweigend brechen kann. */
export const TESTIMONIALS_ANCHOR_ID = "bewertungen";
